//utility function which will take in common fields for logging to the server

const userJSON = (doctorName) => {
  const currentTime = Math.floor(Date.now() / 1000);

  const jsonObj = {
    user_name: doctorName,
    timestamp: currentTime.toString(),
    deployment: {
        platform: "web-app",
        version: "1.0.0"
    }
  };

  return jsonObj; 
};



export default userJSON;
